import { render } from "./RequestAppointments.vue?vue&type=template&id=f98c1926&scoped=true"
import script from "./RequestAppointments.vue?vue&type=script&lang=js"
export * from "./RequestAppointments.vue?vue&type=script&lang=js"

import "./RequestAppointments.vue?vue&type=style&index=0&id=f98c1926&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f98c1926"]])

export default __exports__